import React from 'react';
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {useNavigate} from "react-router-dom";
import ContactsIcon from "@mui/icons-material/Contacts";
import StarsIcon from "@mui/icons-material/Stars";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

const folders = [
    {
        icon: <ContactsIcon fontSize={"small"} />,
        label: "All ",
        slug: "all",
        path: "/dashboard/parents/all"
    }/*,
    {
        icon: <StarsIcon fontSize={"small"} />,
        label: "In Progress",
        slug: "starred",
        path: "/dashboard/teachers/starred"
    },
    {
        icon: <AccessTimeIcon fontSize={"small"} />,
        label: "Completed",
        slug: "frequent",
        path: "/dashboard/teachers/frequent"
    }*/
];
const folders1 = [
    {
        icon: <ContactsIcon fontSize={"small"}/>,
        label: "All ",
        slug: "all",
        path: "/dashboard/teachers/all"
    }/*,
    {
        icon: <StarsIcon fontSize={"small"}/>,
        label: "Active",
        slug: "active",
        path: "/dashboard/teachers/active"
    },
    {
        icon: <AccessTimeIcon fontSize={"small"}/>,
        label: "Inactive",
        slug: "inactive",
        path: "/dashboard/teachers/inactive"
    }*/
];
const FolderDropdown = () => {
    const navigate = useNavigate();
    const [folder, setFolder] = React.useState("");
    return (
        <FormControl sx={{width: 120}} size={"small"}>
            <InputLabel>Folder</InputLabel>
            <Select
                value={folder}
                label="Folder"
                onChange={(event) => setFolder(event.target.value)}
            >
                <MenuItem value="">
                    <em>Select Folder</em>
                </MenuItem>
                {
                    folders.map((folder, index) => (
                        <MenuItem
                            key={index}
                            value={folder}
                            onClick={() => navigate(`/dashboard/parents/${folder.slug}`)}
                        >
                            {folder.label}
                        </MenuItem>
                    ))
                }
            </Select>
        </FormControl>
    );
};
export default FolderDropdown;
